const isBrowser = typeof window !== `undefined`
export const getBookingAcceptanceDay = ()=>{
    if(isBrowser){
     return window.localStorage.bookingAcceptance
     ? JSON.parse(window.localStorage.bookingAcceptance)
     : 2
    }
  }